import React from "react"
import { Box, Flex } from "rebass"
import { get } from "lodash"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import { Counter } from "../counter"

const pi = [
  { id: "left", name: "Left" },
  { id: "right", name: "Right" },
]

const itemPI = []
for (let i = 0; i < pi.length; i++) {
  const item = pi[i]
  itemPI.push(<MenuItem value={item.id} key={i} primaryText={item.name} />)
}

const BoxPosition = (props) => {
  const { data, onPositionValue, onSetItemValue, indexParent } = props
  const positionImage = get(data, "position_image", "left")
  const boxImage = get(data, "position.boxImage", "0px")
  const marginLeftText = get(data, "position.marginLeftText", "0px")
  const marginLeftImage = get(data, "position.marginLeftImage", "0px")
  const bi = boxImage.split("px").join("") * 1
  const mlt = marginLeftText.split("px").join("") * 1
  const mli = marginLeftImage.split("px").join("") * 1

  return (
    <Box w={[1]}>
      <SelectField
        floatingLabelText="Position Image"
        value={positionImage}
        onChange={(event, index, value) =>
          onSetItemValue("position_image", value, indexParent)
        }
        maxHeight={200}
      >
        {itemPI}
      </SelectField>
      <Flex
        w={[1]}
        direction={"row"}
        wrap={"wrap"}
        py={[1]}
        className="child-wrap"
      >
        <Counter
          isDisabled={false}
          title="Box Image"
          onSetValue={(value) =>
            onPositionValue("boxImage", value, indexParent)
          }
          value={bi}
          interval={1}
          subtitle="px"
          minValue={0}
        />
        {positionImage === "left" && (
          <Counter
            isDisabled={false}
            title="Margin Left Image"
            onSetValue={(value) =>
              onPositionValue("marginLeftImage", value, indexParent)
            }
            value={mli}
            interval={1}
            subtitle="px"
            minValue={-500}
            style={{ marginRight: 16 }}
          />
        )}
        {positionImage === "right" && (
          <Counter
            isDisabled={false}
            title="Margin Left Text"
            onSetValue={(value) =>
              onPositionValue("marginLeftText", value, indexParent)
            }
            value={mlt}
            interval={1}
            subtitle="px"
            minValue={-500}
          />
        )}
      </Flex>
    </Box>
  )
}

export default BoxPosition



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/carouselanimation/BoxPosition.js